import React from 'react';
import { Card, CardContent } from './ui/card';
import { Check } from 'lucide-react';
import TemplatePreview from './TemplatePreview';

const RealisticTemplateSelector = ({ selectedTemplate, onSelectTemplate }) => {
  const templates = [
    {
      id: 'classic',
      name: 'Classic (Black & White)',
      description: 'Simple black and white prescription pad style',
      variant: 'classic',
    },
    {
      id: 'modern',
      name: 'Modern Colored',
      description: 'Colored masthead with customizable clinic details',
      variant: 'modern',
    },
    {
      id: 'govt-hospital',
      name: 'Government Hospital',
      description: 'Select from list of government hospitals',
      variant: 'govt',
    },
    {
      id: 'private-hospital',
      name: 'Private Hospital',
      description: 'Select from list of private hospitals',
      variant: 'private-hospital',
    },
    {
      id: 'private-clinic',
      name: 'Private Clinic',
      description: 'Select from list of private clinics',
      variant: 'clinic',
    },
  ];

  return (
    <div className="mb-6">
      <h3 className="text-lg font-semibold mb-4">📋 Choose Certificate Template</h3>
      <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-5 gap-3">
        {templates.map((template) => (
          <Card
            key={template.id}
            data-testid={`template-card-${template.id}`}
            className={`cursor-pointer transition-all duration-200 hover:shadow-lg ${
              selectedTemplate === template.id ? 'ring-2 ring-pink-600' : ''
            }`}
            onClick={() => onSelectTemplate(template.id)}
          >
            <CardContent className="p-3">
              <div className="relative">
                <div className="aspect-[3/4] bg-white border border-gray-200 rounded overflow-hidden shadow-sm">
                  <TemplatePreview variant={template.variant} />
                </div>
                {selectedTemplate === template.id && (
                  <div className="absolute top-2 right-2 bg-pink-600 text-white rounded-full p-1 shadow">
                    <Check className="h-3 w-3" />
                  </div>
                )}
              </div>
              <div className="mt-3">
                <p className="font-semibold text-xs text-gray-800">{template.name}</p>
                <p className="text-[11px] text-gray-600 mt-1 leading-snug">{template.description}</p>
              </div>
            </CardContent>
          </Card>
        ))}
      </div>
    </div>
  );
};

export default RealisticTemplateSelector;